import { render } from "./Order-page.vue?vue&type=template&id=03ceb7e3&scoped=true"
import script from "./Order-page.vue?vue&type=script&lang=js"
export * from "./Order-page.vue?vue&type=script&lang=js"

import "./Order-page.vue?vue&type=style&index=0&id=03ceb7e3&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ceb7e3"]])

export default __exports__